import React, { useState, useEffect, useContext, useRef } from "react";
import { ChatbotContext } from '../Context/ChatbotContext';
import parse from 'html-react-parser';


import Image1 from '../assets/img1Sect4.svg';
import Image2 from '../assets/img2Sect4.svg';
import Image3 from '../assets/img3Sect4.svg';
import Image4 from '../assets/img4Sect4.svg';
import Image5 from '../assets/img5Sect4.svg';

const Carrusel = () => {
  const { toggleChat } = useContext(ChatbotContext);
  const carruselRef = useRef(null);
  const baseStyles = {
    containerLeft: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
    },
    title: {
      display: "flex",
      alignItems: "flex-start",
      lineHeight: "120%",
    },
    DescriptionB: {
      display: "block",
      textAlign: "left",
    },
    DescriptionC: {
      display: "block",
      textAlign: "start",
      paddingTop: "2%",
    },
  };

  const flashcardData = {
    3: {
      title: "Carga de Documentos",
      descriptionB: "Transforma tus PDFs, DOCs y bases de datos en conocimiento accesible.",
      gridColumns: "md:grid-cols-[45%,55%]",
      image: (
        <img
          src={Image1}
          alt="Gráfico"
          className="transition duration-500 ease-in-out transform hover:scale-105 hover:rotate-8  w-full h-[400px] mb:h-[250px] 2xl:h-[500px] mb:mb-4"
        />
      ),
      style: {
        ...baseStyles,
      },
    },
    4: {
      title: "Indexación Inteligente",
      descriptionB: "La IA organiza la información para búsquedas rápidas y precisas.",
      gridColumns: "md:grid-cols-[45%,55%]",
      image: (
        <img
          src={Image2}
          alt="Gráfico"
          className="transition duration-500 ease-in-out transform hover:scale-90 hover:rotate-20 w-full h-[400px] mb:h-[250px] 2xl:h-[500px] mb:mb-4"
        />
      ),
      style: {
        ...baseStyles,
      },
    },
    5: {
      title: "Interacción Natural",
      descriptionB: "Los empleados hacen preguntas en lenguaje natural, MENTOR-IA responde al instante.",
      gridColumns: "md:grid-cols-[45%,55%]",
      image: (
        <img
          src={Image3}
          alt="Gráfico"
          className="transition duration-500 ease-in-out transform hover:scale-110 hover:rotate-12 w-full h-[400px] mb:h-[250px] 2xl:h-[500px] mb:mb-4"
        />
      ),
      style: {
        ...baseStyles,
      },
    },
    6: {
      title: "Visualización Clara",
      descriptionB: "Respuestas concisas con acceso directo a documentos completos.",
      gridColumns: "md:grid-cols-[45%,55%]",
      image: (
        <img
          src={Image4}
          alt="Gráfico"
          className="transition duration-500 ease-in-out transform hover:scale-105 hover:rotate-8 w-full h-[400px] mb:h-[250px] 2xl:h-[500px] mb:mb-4"
        />
      ),
      style: {
        ...baseStyles,
      },
    },
    7: {
      title: "Estadísticas Dinámicas",
      descriptionB: "Monitorea el uso y ajusta la formación según las necesidades reales.",
      gridColumns: "md:grid-cols-[45%,55%]",
      image: (
        <img
          src={Image5}
          alt="Gráfico"
          className="transition duration-500 ease-in-out transform hover:scale-80 p-2 mb-[5%] hover:rotate-6 w-full h-[300px] mb:h-[200px] 2xl:h-[450px] mb:mb-4"
        />
      ),
      style: {
        ...baseStyles,
      },
    },
  };

  const cards = [flashcardData[3], flashcardData[4], flashcardData[5], flashcardData[6], flashcardData[7]];

  const [currentIndex, setCurrentIndex] = useState(0);
  const [userInteracted, setUserInteracted] = useState(false);

  // Funciones de navegación
  const handlePrev = () => {
    setCurrentIndex((prev) => (prev === 0 ? cards.length - 1 : prev - 1));
  };

  const handleNext = () => {
    setCurrentIndex((prev) => (prev === cards.length - 1 ? 0 : prev + 1));
  };

  // Navegación directa por botón de título
  const goToCard = (index) => {
    setCurrentIndex(index);
    setUserInteracted(true);
  };



  // Automático si no hay interacción
  useEffect(() => {
    if (!userInteracted) {
      const timer = setTimeout(() => {
        setCurrentIndex((prev) => (prev === cards.length - 1 ? 0 : prev + 1));
      }, 10000);
      return () => clearTimeout(timer);
    }
  }, [currentIndex, userInteracted]);

  // Reiniciar el estado de interacción después de 10 segundos
  useEffect(() => {
    if (userInteracted) {
      const resetTimer = setTimeout(() => setUserInteracted(false), 10000);
      return () => clearTimeout(resetTimer);
    }
  }, [userInteracted]);

  const data = cards[currentIndex];

  return (
    <section className="bg-white flex flex-col justify-start my-8 mb:my-4 " id="carrusel">

      <div className="divider-conteiner space-y-2 ">
        <h2 className="divider-titule ">¡MENTOR-IA en Acción!</h2>
        <h2 className="divider-body">¿Cómo funciona?</h2>
      </div>


      <div className="actbtn-section " id="stats">

        {/* Contenedor del texto */}
        <div className="actbtn-container">
  {cards.map((card, index) => (
    <button
  key={index}
  onClick={() => goToCard(index)}
  disabled={currentIndex === index}
  className={`act-button ${currentIndex === index ? "!border-[#FF00B1] !text-[#FF00B1]   cursor-not-allowed" : " border-[#B6B7CD] !text-[#B6B7CD]  hover:!bg-pink-600 cursor-pointer"}`}
>
  {card.title}
</button>

  ))}
</div>

      </div>
      <div id="carrusel-section" className={`p-8 pb-0 pt-0 mb:p-4   overflow-hidden m-4 mb:m-4 grid grid-cols-1 ${data.gridColumns || "md:grid-cols-[45%,55%]"} space-x-2`}>
        <div style={data.style?.containerLeft || {}}>
          <div className="text-[55px] mb:text-4xl flex justify-center space-x-4 mb-8 mb:mb-4">
          </div>

          <div className="flex flex-col space-y-10">
            <div className="lg:h-[100%] ">
              <h2 className="carousel-title" style={data.style?.title || {}}>
                {data.title}
              </h2>
              <p className="carousel-description break-words" style={data.style?.DescriptionB || {}}>
                {parse(data.descriptionB || "")}
              </p>
            </div>
            <div className="flex justify-center mt-4 md:hidden md:justify-center" style={data.style?.DescriptionI || {}}>
              {data.image}
            </div>

            <div className="flex justify-center md:justify-start mt-2">
              <button className="carr-button" onClick={toggleChat} >Comienza tu demo</button>
            </div>
          </div>
        </div>

        <div className="hidden md:flex items-end h-[100%] p-[5%">
          {data.image}
        </div>
      </div>
    </section>
  );
};

export default Carrusel;
